export const DEFAULT_DATA_LOG_RETENTION_PERIOD = 180;
export const MIN_DATA_LOG_RETENTION_PERIOD = 30;
export const MAX_DATA_LOG_RETENTION_PERIOD = 1200;
